import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';

// assets
import { CheckCircleFilled, ClockCircleFilled } from '@ant-design/icons';

// ==============================|| AVATAR STATUS ICONS ||============================== //

const AvatarStatus = ({ status }) => {
	const theme = useTheme();

	switch (status) {
		case 'ONLINE':
			return (
				<Tooltip
					slotProps={{
						popper: {
							modifiers: [
								{
									name: 'offset',
									options: {
										offset: [0, -10],
									},
								},
							],
						},
					}}
					title="On-Screen"
					placement="top"
					TransitionComponent={Zoom}
				>
					<CheckCircleFilled style={{ color: '#0000ff' }} />
				</Tooltip>
			);

		case 'AWAY':
			return (
				<Tooltip
					slotProps={{
						popper: {
							modifiers: [
								{
									name: 'offset',
									options: {
										offset: [0, -10],
									},
								},
							],
						},
					}}
					title="On-Site"
					placement="top"
					TransitionComponent={Zoom}
				>
					<CheckCircleFilled style={{ color: theme.palette.success.main }} />
				</Tooltip>
			);

		case 'OFFLINE':
			return (
				<Tooltip
					slotProps={{
						popper: {
							modifiers: [
								{
									name: 'offset',
									options: {
										offset: [0, -10],
									},
								},
							],
						},
					}}
					title="Offline"
					placement="top"
					TransitionComponent={Zoom}
				>
					<ClockCircleFilled style={{ color: theme.palette.text.secondary }} />
				</Tooltip>
			);

		default:
			return null;
	}
};

AvatarStatus.propTypes = {
	status: PropTypes.string,
};

export default AvatarStatus;
